import { render, staticRenderFns } from "./app.vue?vue&type=template&id=d4bdb32c&lang=pug&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serg/my/projects/pub.settv.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4bdb32c')) {
      api.createRecord('d4bdb32c', component.options)
    } else {
      api.reload('d4bdb32c', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=d4bdb32c&lang=pug&", function () {
      api.rerender('d4bdb32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/app.vue"
export default component.exports